import './credentials.css'

import { InfoCircleOutlined } from '@ant-design/icons'
import { CredentialManagement } from '@components/DriverManagement/Credentials/components/CredentialManagementTab/CredentialManagement'
import { DriverCredentials } from '@components/DriverManagement/Credentials/components/DriverCredentialsTab/DriverCredentials'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useUserSettings } from '@hooks/settings'
import { Button, Tabs, Tooltip } from 'antd'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'

export function Credentials() {
  const [activeKey, setActiveKey] = useState('Driver Credentials')
  const [selectedCredential, setSelectedCredential] = useState(null)
  const { updateSetting, getSetting } = useUserSettings()
  const storageKey = 'driver-credentials-active-tab'
  const updateStickyTab = async (key) => {
    setActiveKey(key)
    await updateSetting(storageKey, key)
  }
  useEffect(() => {
    const queryKey = queryString.parse(window.location.search)?.key
    if (queryKey) {
      setActiveKey('Driver Credentials')
    } else {
      getSetting(storageKey).then((key) => {
        key && setActiveKey(key)
      })
    }
  }, [])

  const handleCredentialLink = async (credentialId) => {
    setSelectedCredential(credentialId)
    await updateStickyTab('Credential Management')
  }

  const items = [
    {
      label: 'Driver Credentials',
      key: 'Driver Credentials',
    },
    {
      label: 'Credential Management',
      key: 'Credential Management',
    },
  ]

  return (
    <Vertical bg='default' border='all' borderRadius='6px 6px 0 0'>
      <Tabs
        className='px-3'
        defaultActiveKey={activeKey || 'Driver Credentials'}
        onChange={updateStickyTab}
        activeKey={activeKey}
        items={items}
      />
      <Vertical style={{ flex: 1 }}>
        {activeKey === 'Driver Credentials' ? (
          <DriverCredentials
            title='Driver Credentials'
            updateSetting={updateSetting}
            handleCredentialLink={handleCredentialLink}
          />
        ) : (
          <CredentialManagement
            title='Credential Management'
            updateSetting={updateSetting}
            selectedCredential={selectedCredential}
            setSelectedCredential={setSelectedCredential}
          />
        )}
      </Vertical>
    </Vertical>
  )
}
